import React from "react";
import { Card } from "reactstrap";
import { Icon } from "../../../Component";
import { TotalOrderChart } from "../../charts/e-commerce/EcomCharts";

const Orders = ({data,isLoading}) => { 
  return (
    <Card>
      <div className="nk-ecwg nk-ecwg3">
        <div className="card-inner pb-0">
          <div className="card-title-group">
            <div className="card-title">
              <h6 className="title">Orders</h6>
            </div>
          </div>
          <div className="data">
            <div className="data-group">
              <div className="amount">{data?.total}</div>
              <div className="info text-end">
                <span className={`change ${data?.growth ? "up" : "down"} text-danger`}>
                  <Icon name={data?.growth ? "arrow-long-up" : "arrow-long-down"}></Icon>{data?.percent_change}%
                </span>
                <br />
                <span>vs. last week</span>
              </div>
            </div>
          </div>
        </div>
        <div className="nk-ecwg3-ck">
         {isLoading?"": <TotalOrderChart data={data?.totalOrders} isLoading={isLoading} />}
        </div>
      </div>
    </Card>
  );
};
export default Orders;
